import { OrgTreeSelect } from "@/components/common/OrgTreeSelect";
import { SelectField } from "@/components/common";
import { useTran } from "@/hooks";
import { useEntryDataStore } from "../../hooks/useDataEntryStore";
import { Label } from "@/components/ui/label";

export function NxmapSyncForm({
  organizationId,
  setOrganizationId,
  masterDataYears = [],
  selectedYear,
  setSelectedYear,
}) {
  const { t } = useTran();
  const { disclosureOrgTree } = useEntryDataStore();

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-3 items-end">
        <div className="space-y-2">
          <Label>
            {t("Organization")}
            <span className="ml-1 text-destructive">*</span>
          </Label>
          <OrgTreeSelect
            tree={disclosureOrgTree}
            value={organizationId}
            onChange={setOrganizationId}
            placeholder={t("Select organization")}
            showAllOption={false}
            className="w-full"
          />
        </div>
        <SelectField
          label={t("Year")}
          options={masterDataYears.map((y) => String(y))}
          value={selectedYear}
          onValueChange={setSelectedYear}
          placeholder={t("Select year")}
        />
      </div>
    </div>
  );
}
